// extracted by mini-css-extract-plugin
export default {"error_section":"styles_error_section__UymzN","error_form":"styles_error_form__jGuXM"};